$(document).ready(function() {
    const cards = document.querySelectorAll(".piq-testimonials__slider .piq-testimonials__item");
    let hiddenCards = document.querySelectorAll('.piq-testimonials__slider .piq-testimonials__item[aria-hidden="true"]');

    function hideNonVisibleCards() {
        hiddenCards = document.querySelectorAll('.piq-testimonials__slider .piq-testimonials__item[aria-hidden="true"]');

        cards.forEach(function (card) {
            card.querySelectorAll('a, button').forEach(function (focusableElement) {
                focusableElement.removeAttribute('tabindex');
            });
        });

        hiddenCards.forEach(function (card) {
            card.querySelectorAll('a, button').forEach(function (focusableElement) {
                focusableElement.setAttribute('tabindex', -1);
            });
        });
    }

    $('.piq-testimonials__slider').on('init', function (e, slick) {
        hiddenCards = document.querySelectorAll('.piq-testimonials__slider .piq-testimonials__item[aria-hidden="true"]');
        hideNonVisibleCards();
    });

    $('.piq-testimonials__slider').on('afterChange', function (e, slick, currentSlide, nextSlide) {
        hideNonVisibleCards();
    });

    const readDataBool = (el, attrName, fallback) => {
        const raw = el.getAttribute(attrName);
        if (raw === null || raw === undefined || raw === '') return fallback;
        if (raw === 'true') return true;
        if (raw === 'false') return false;
        return fallback;
    };

    const readDataNumber = (el, attrName, fallback) => {
        const raw = el.getAttribute(attrName);
        const num = Number.parseFloat(String(raw ?? ''));
        return Number.isFinite(num) ? num : fallback;
    };

    const applyLeftRightAnimation = (sliderEl) => {
        const listEl = sliderEl.querySelector('.slick-list');
        const trackEl = sliderEl.querySelector('.slick-track');
        if (!listEl || !trackEl) return;

        const cs = window.getComputedStyle(listEl);
        const padLeft = Number.parseFloat(cs.paddingLeft) || 0;
        const padRight = Number.parseFloat(cs.paddingRight) || 0;

        const listWidth = listEl.clientWidth || 0;
        const trackWidth = trackEl.scrollWidth || 0;

        const startLeftExtraPx = 200;
        const restLeft = padLeft - startLeftExtraPx;
        const endLeft = (listWidth - padRight - trackWidth);

        // Force the base (non-animated) position.
        trackEl.style.left = `${restLeft}px`;

        const extraTravelPx = 40;
        const delta = Math.min(0, endLeft - restLeft - extraTravelPx); // negative or 0 (with small buffer)

        sliderEl.style.setProperty('--piq-lr-distance', `${Math.max(0, trackWidth - listWidth)}px`);
        sliderEl.style.setProperty('--piq-lr-from', `0px`);
        sliderEl.style.setProperty('--piq-lr-to', `${delta}px`);

        // Duration is provided by customizer (seconds to go one-way).
        const durationSec = Math.max(1, readDataNumber(sliderEl, 'data-left-right-speed', 15));
        sliderEl.style.setProperty('--piq-lr-duration', `${durationSec}s`);
    };

    $('.piq-testimonials__slider').each(function () {
        const sliderEl = this;
        const sliderArrows = readDataBool(sliderEl, 'data-arrows', true);
        const wantsLeftRightAnimation = readDataBool(sliderEl, 'data-left-right-animation', false);
        const isBigScreen = window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
        const leftRightAnimation = wantsLeftRightAnimation && isBigScreen;

        $(this).slick({
        dots: false,
        arrows: leftRightAnimation ? false : sliderArrows,
        infinite: leftRightAnimation ? false : true,
        pauseOnHover: leftRightAnimation ? true : false,
        swipeToSlide: !leftRightAnimation,
        swipe: !leftRightAnimation,
        draggable: !leftRightAnimation,
        accessibility: false,
        autoplay: !leftRightAnimation,
        autoplaySpeed: 3000,
        centerMode: true,
        centerPadding: '150px',
        useTransform: !leftRightAnimation,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true,
        prevArrow: '<button class="arrow-left" aria-label="previous arrow"><svg width="42" height="44" viewBox="0 0 42 44" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_dddd_2007_2836)"><rect x="1" y="1" width="35" height="35" rx="17.5" fill="white"/><path d="M19 14L15 18.5L19 23" stroke="black" stroke-width="1.8" stroke-linecap="square"/></g><defs><filter id="filter0_dddd_2007_2836" x="0" y="0" width="42" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="0.5"/><feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2007_2836"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="1" dy="1"/><feGaussianBlur stdDeviation="1"/><feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.09 0"/><feBlend mode="normal" in2="effect1_dropShadow_2007_2836" result="effect2_dropShadow_2007_2836"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="2" dy="3"/><feGaussianBlur stdDeviation="1"/><feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.05 0"/><feBlend mode="normal" in2="effect2_dropShadow_2007_2836" result="effect3_dropShadow_2007_2836"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="3" dy="5"/><feGaussianBlur stdDeviation="1.5"/><feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.01 0"/><feBlend mode="normal" in2="effect3_dropShadow_2007_2836" result="effect4_dropShadow_2007_2836"/><feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_2007_2836" result="shape"/></filter></defs></svg></button>',
        nextArrow: '<button class="arrow-right" aria-label="next arrow"><svg width="42" height="44" viewBox="0 0 42 44" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_dddd_2007_2838)"><rect width="35" height="35" rx="17.5" transform="matrix(-1 0 0 1 36 1)" fill="white"/><path d="M18 14L22 18.5L18 23" stroke="black" stroke-width="1.8" stroke-linecap="square"/></g><defs><filter id="filter0_dddd_2007_2838" x="0" y="0" width="42" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="0.5"/><feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2007_2838"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="1" dy="1"/><feGaussianBlur stdDeviation="1"/><feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.09 0"/><feBlend mode="normal" in2="effect1_dropShadow_2007_2838" result="effect2_dropShadow_2007_2838"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="2" dy="3"/><feGaussianBlur stdDeviation="1"/><feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.05 0"/><feBlend mode="normal" in2="effect2_dropShadow_2007_2838" result="effect3_dropShadow_2007_2838"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="3" dy="5"/><feGaussianBlur stdDeviation="1.5"/><feColorMatrix type="matrix" values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.01 0"/><feBlend mode="normal" in2="effect3_dropShadow_2007_2838" result="effect4_dropShadow_2007_2838"/><feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_2007_2838" result="shape"/></filter></defs></svg></button>',
        responsive: [
            {
                breakpoint: 1920,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1080,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '100px'
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '50px',
                    dots: true,
                    arrows: false
                }
            }
        ]
        });

        if (leftRightAnimation) {
            sliderEl.classList.add('piq-testimonials__slider--left-right-animation');
            $(this).on('setPosition', function () {
                applyLeftRightAnimation(sliderEl);
            });
            applyLeftRightAnimation(sliderEl);

        }
    });

    $('.piq-testimonials__slider').on("click", () => {
        // Pause rotation if toggle exists
        document.querySelector('.piq-testimonials .js-nss-animation-toggle-wrap')?.pause?.();
    });

    const sectionEl = document.querySelector('.piq-testimonials');
    const configuredMaxHeight = sectionEl ? readDataNumber(sectionEl, 'data-text-max-height', 0) : 0;

    if (Number.isFinite(configuredMaxHeight) && configuredMaxHeight > 0) {
        $('.piq-testimonials__item-text').css('max-height', configuredMaxHeight);
    } else {
        var htes = $('.piq-testimonials__item-image').innerHeight();
        $('.piq-testimonials__item-text').css('max-height', htes);
    }

});